import UsersModule from './UsersModule'
export default UsersModule
